import React, { useEffect, useState, useRef } from "react";
import Select from './select.js';
import Preview from './preview.js';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import axios from 'axios';
import configData from '../Config';
import { registerArabicFont } from "../Utils/registerarabicfont.js";

const formatTypes = [
  { id: 'pdf', name: "PDF" },
  { id: 'image', name: "Image" },
]

const getImage = (userid, usertoken, countryid, listingid, index) => {
  const requestData = {
    countryid: countryid,
    listingid: listingid,
    index: index
  };

  console.log('Request data:', requestData);

  return axios.post(configData.SECUREURL + configData.GETIMAGE, requestData, {
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      "userid": userid,
      "usertoken": usertoken
    },
    responseType: 'blob',
  }).then(res => {
    return URL.createObjectURL(res.data);
  }).catch(err => {
    console.error('Error fetching image:', err);
    throw err;
  });
};

function Save({ templates = [], state, setState, listings, listing, filename }) {
  const [templatecontent, setTemplatecontent] = useState('');
  const [templatetext, setTemplatetext] = useState('');
  const [templateid, setTemplateid] = useState("");
  const [format, setFormat] = useState("pdf");

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');

  const printRef = useRef();

  const handleClose = () => {
    setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
  };

  useEffect(() => {
    if (!templates || templates.length === 0) {
    }

    const currentTemplate = templates.find(template => template.id === templateid) || templates[0];

    let content = listing.descriptionunfiltered
      .filter(item => item.data && item.data.replace(/\r/g, '').trim() !== '')
      .map(item => {
        const cleanData = item.data.replace(/\r/g, '').trim();

        const className = item.rtl
          ? 'listings_textdirectionalityright listings_textalignright'
          : 'listings_textdirectionalityleft listings_textalignleft';

        const direction = item.rtl ? 'rtl' : 'ltr';

        return `<div class="${className}" dir="${direction}">${cleanData}</div>`;
      })
      .join('\n');

    setTemplatecontent(content);
  }, [templates]);

  const handleSave = async () => {
    if (!printRef.current) return;

    if (format === 'pdf') {
      setLoading(true);
      try {
        const doc = new jsPDF();

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const margin = 15;
        let currentY = margin;

        // --- 1. HEADER SECTION ---
        doc.setFontSize(16);
        doc.setTextColor(30, 30, 30);
        doc.text("Property Listing", margin, currentY);
        currentY += 6;

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(12);
        doc.setTextColor(30, 30, 30);
        doc.text(configData.DOMAIN.toUpperCase(), margin, currentY);
        currentY += 10;

        registerArabicFont(doc);
        doc.setFontSize(10);
        doc.setTextColor(100, 100, 100);
        doc.text(`Listing ID: ${listing.id || ''} | Community: ${listing.community || ''} | Type: ${listing.type || ''} (${listing.agreement || ''})`, margin, currentY);
        currentY += 8;

        // Divider line
        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.5);
        doc.line(margin, currentY, pageWidth - margin, currentY);
        currentY += 10;

        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        doc.text("Description:", margin, currentY);
        currentY += 6;

        doc.setFontSize(10);
        doc.setTextColor(50, 50, 50);
        const descItems = listing.descriptionunfiltered || [];

        for (let i = 0; i < descItems.length; i++) {
          const item = descItems[i];
          const lineText = (item.data || '').replace(/[\r\n]+/g, '');
          console.log(item)
          if (lineText.trim() === '') {
            currentY += 5;
            continue;
          }

          const isRtl = item.rtl == 1;
          const maxWidth = pageWidth - (margin * 2);
          const splitLine = doc.splitTextToSize(lineText, maxWidth);

          if (currentY + (splitLine.length * 5) > pageHeight - margin) {
            doc.addPage();
            currentY = margin;
          }

          if (isRtl) {
            const cleanedLines = splitLine.map(line => line.replace(/[.:،؛؟\-_[\]{}()\/\\|*#@!~+=`^&%]/g, ''));
            doc.text(cleanedLines, pageWidth - margin, currentY, { align: 'right' });
          } else {
            doc.text(splitLine, margin, currentY, { align: 'left' });
          }

          currentY += splitLine.length * 5;
        }

        currentY += 10;

        // --- 3. IMAGES GALLERY GRID ---
        const imagesList = listing.images || [];
        if (imagesList.length > 0) {
          if (currentY > pageHeight - 50) {
            doc.addPage();
            currentY = margin;
          }

          doc.setFontSize(12);
          doc.setTextColor(0, 0, 0);
          doc.text("Images:", margin, currentY);
          currentY += 10;

          const imgWidth = 85;
          const imgHeight = 60;
          const xOffsetStep = 95;
          let startX = margin;
          let colCount = 0;

          for (let i = 0; i < imagesList.length; i++) {
            try {
              const objectUrl = await getImage(
                state.user.userid,
                state.user.usertoken,
                state.selectedcountry,
                listing.id,
                i
              );

              const base64Image = await new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = 'anonymous';
                img.onload = () => {
                  const canvas = document.createElement('canvas');
                  canvas.width = img.naturalWidth;
                  canvas.height = img.naturalHeight;
                  const ctx = canvas.getContext('2d');
                  ctx.drawImage(img, 0, 0);
                  resolve(canvas.toDataURL('image/jpeg'));

                  // Clean up memory
                  URL.revokeObjectURL(objectUrl);
                };
                img.onerror = (err) => {
                  URL.revokeObjectURL(objectUrl);
                  reject(err);
                };
                img.src = objectUrl;
              });

              // Check if we need a new page for the next row of images
              if (currentY + imgHeight > pageHeight - margin) {
                doc.addPage();
                currentY = margin;
                colCount = 0;
                startX = margin;
              }

              const currentX = startX + (colCount * xOffsetStep);
              doc.addImage(base64Image, 'JPEG', currentX, currentY, imgWidth, imgHeight);

              colCount++;
              if (colCount >= 2) { // 2 images per row
                colCount = 0;
                currentY += imgHeight + 10;
              }
            } catch (error) {
              console.log(`Failed to load image index ${i} for PDF:`, error);
            }
          }

          if (colCount > 0) {
            currentY += imgHeight + 10;
          }
        }

        // Save PDF
        const fileName = 'listing_' + (listing.id || 'report') + '.pdf';
        doc.save(fileName.toLowerCase());
        setResult("Saved Successfully");

      } catch (error) {
        console.error('Error generating PDF:', error);
        setResult("Error Saving PDF");
      } finally {
        setLoading(false);
      }
    }

    if (format === 'image') {
      setLoading(true)
      const objectUrls = [];

      try {
        const description = Array.isArray(listing.descriptionunfiltered)
          ? listing.descriptionunfiltered
            .map(item => typeof item === 'string' ? item : (item.data || ''))
            .join('\n')
          : listing.descriptionunfiltered || '';

        for (let i = 0; i < listing.images.length; i++) {
          const objectUrl = await getImage(
            state.user.userid,
            state.user.usertoken,
            state.selectedcountry,
            listing.id,
            i
          );

          objectUrls.push(objectUrl);

          const img = new Image();

          await new Promise((resolve, reject) => {
            img.onload = resolve;
            img.onerror = reject;
            img.src = objectUrl;
          });

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          const width = img.naturalWidth;
          const imageHeight = img.naturalHeight;
          const padding = 30;
          const fontSize = Math.max(18, Math.round(width * 0.025));
          const lineHeight = fontSize * 1.6;
          const maxWidth = width - padding * 2;

          ctx.font = `${fontSize}px Arial`;

          const lines = [];

          description.split('\n').forEach(paragraph => {
            if (!paragraph.trim()) {
              lines.push('');
              return;
            }

            let line = '';

            paragraph.split(/\s+/).forEach(word => {
              const testLine = line ? `${line} ${word}` : word;

              if (ctx.measureText(testLine).width > maxWidth && line) {
                lines.push(line);
                line = word;
              } else {
                line = testLine;
              }
            });

            if (line) lines.push(line);
          });

          const descriptionHeight = padding * 2 + lines.length * lineHeight;

          canvas.width = width;
          canvas.height = imageHeight + descriptionHeight;

          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, width, imageHeight);

          ctx.fillStyle = '#000000';
          ctx.font = `${fontSize}px Arial`;
          ctx.textBaseline = 'top';

          let y = imageHeight + padding;

          lines.forEach(line => {
            ctx.fillText(line, padding, y);
            y += lineHeight;
          });

          const link = document.createElement('a');
          link.download = `${filename}_${i + 1}.png`;
          link.href = canvas.toDataURL('image/png');
          link.click();

          await new Promise(resolve => setTimeout(resolve, 200));
        }

        setResult('Images saved');
      } catch (error) {
        console.log(error);
        setResult('Failed to save images');
      } finally {
        objectUrls.forEach(url => URL.revokeObjectURL(url));
        setLoading(false)
      }
    }

  };

  return (
    <div className='modal_body'>
      <div className="modal_row">
        <div className="modal_rowsection">
          <Select data={formatTypes} itemid={format} setItemid={setFormat} label='Format' />
        </div>
      </div>

      <div className="modal_printable">
        <div className='modal_row'>
          <div className='modal_rowsection'>
            <Preview content={templatecontent} images={listing.images} printRef={printRef} />
          </div>
        </div>
      </div >

      <div className='modal_actions'>
        {result && <div className='modal_result'>{result}</div>}
        <div className='modal_buttons'>
          <div className="modal_buttoncontainer">
            <button className="modal_button" onClick={handleSave} disabled={loading}>{loading ? 'Loading' : 'Save'}</button>
          </div>
          <div className="modal_buttoncontainer">
            <button className="modal_button" onClick={handleClose}>Cancel</button>
          </div>
        </div>
      </div>

    </div >
  );
}

export default Save;